import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/premiumpositioning.webp';
import screenshot_target from '../../../images/letterfunnel/petergerritsen.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Peter Gerritsen"
      firstname="Peter"
      companyname="Premium Positioning"
      competition="HxGN SmartNet en Trimble VRS Now"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/petergerritsen.js